import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  milestones: [],
  creating: false,
  selectedMilestone: null,
  detailsLoading: false,
  detailsError: null,
};

const milestoneSlice = createSlice({
  name: "companyMilestone",
  initialState,
  reducers: {
    // Get Milestones
    getMilestonesStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getMilestonesSuccess: (state, action) => {
      state.loading = false;
      state.milestones = action.payload.milestones || action.payload || [];
      state.error = null;
    },
    getMilestonesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Get Milestone Details
    getMilestoneDetailsStart: (state) => {
      state.detailsLoading = true;
      state.detailsError = null;
    },
    getMilestoneDetailsSuccess: (state, action) => {
      state.detailsLoading = false;
      state.selectedMilestone = action.payload;
      state.detailsError = null;
    },
    getMilestoneDetailsFailure: (state, action) => {
      state.detailsLoading = false;
      state.detailsError = action.payload;
    },
    clearSelectedMilestone: (state) => {
      state.selectedMilestone = null;
      state.detailsError = null;
    },

    // Create Milestone
    createMilestoneStart: (state) => {
      state.creating = true;
      state.error = null;
    },
    createMilestoneSuccess: (state, action) => {
      state.creating = false;
      state.milestones.push(action.payload);
      state.error = null;
    },
    createMilestoneFailure: (state, action) => {
      state.creating = false;
      state.error = action.payload;
    },

    // Update Milestone
    updateMilestoneStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateMilestoneSuccess: (state, action) => {
      state.loading = false;
      const updatedMilestone = action.payload;
      state.milestones = state.milestones.map((milestone) =>
        milestone.id === updatedMilestone.id ? updatedMilestone : milestone,
      );
      if (state.selectedMilestone?.milestone?.id === updatedMilestone.id) {
        state.selectedMilestone.milestone = {
          ...state.selectedMilestone.milestone,
          ...updatedMilestone,
        };
      }
      state.error = null;
    },
    updateMilestoneFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Clear Error
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  getMilestonesStart,
  getMilestonesSuccess,
  getMilestonesFailure,
  getMilestoneDetailsStart,
  getMilestoneDetailsSuccess,
  getMilestoneDetailsFailure,
  clearSelectedMilestone,
  createMilestoneStart,
  createMilestoneSuccess,
  createMilestoneFailure,
  updateMilestoneStart,
  updateMilestoneSuccess,
  updateMilestoneFailure,
  clearError,
} = milestoneSlice.actions;

export default milestoneSlice.reducer;
